import { PDF_CONTENT_GAP, addSectionTitle, ensurePageSpace } from "./pdfLayout";

const number = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;

function compact(value) {
  const amount = number(value);
  const absolute = Math.abs(amount);
  if (absolute >= 1e9) return `${(amount / 1e9).toFixed(1)}B`;
  if (absolute >= 1e6) return `${(amount / 1e6).toFixed(1)}M`;
  if (absolute >= 1e3) return `${(amount / 1e3).toFixed(1)}K`;
  return `${Math.round(amount)}`;
}

function legendHeight(series, columns = 3) {
  return series.length ? Math.ceil(series.length / columns) * 13 + 10 : 0;
}

export function addHorizontalStackedBarChart(ctx, config = {}, startY) {
  const { doc, margins, usableWidth } = ctx;
  const { title = "Chart", subtitle = "", note = "", rows = [], series = [], valuePrefix = "$" } = config;
  const rowHeight = 17;
  const labelWidth = Math.min(160, usableWidth * 0.34);
  const plotWidth = usableWidth - labelWidth - 18;
  const plotHeight = Math.max(rowHeight, rows.length * rowHeight);
  const keyHeight = legendHeight(series, 3);
  const frameHeight = 24 + plotHeight + keyHeight + (note ? 16 : 0);
  let y = ensurePageSpace(ctx, startY, frameHeight + 42);
  y = addSectionTitle(ctx, title, y);
  if (subtitle) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(85);
    doc.text(subtitle, margins.left, y);
    y += 12;
  }

  const chartX = margins.left;
  const plotX = chartX + labelWidth;
  const plotTop = y + 10;
  const maxValue = Math.max(1, ...rows.map((row) => series.reduce((sum, item) => sum + Math.max(0, number(row[item.key])), 0)));

  doc.setDrawColor(215);
  doc.roundedRect(chartX, y, usableWidth, frameHeight, 5, 5, "S");
  for (let index = 0; index <= 4; index += 1) {
    const x = plotX + (plotWidth * index) / 4;
    doc.setDrawColor(225);
    doc.setLineWidth(0.3);
    doc.line(x, plotTop, x, plotTop + plotHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
    doc.setTextColor(90);
    doc.text(`${valuePrefix}${compact((maxValue * index) / 4)}`, x, plotTop + plotHeight + 10, { align: index === 0 ? "left" : index === 4 ? "right" : "center" });
  }

  rows.forEach((row, rowIndex) => {
    const centerY = plotTop + rowIndex * rowHeight + rowHeight / 2;
    const labelLines = doc.splitTextToSize(String(row.label || ""), labelWidth - 10).slice(0, 2);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
    doc.setTextColor(35);
    doc.text(labelLines, plotX - 7, centerY - (labelLines.length - 1) * 3, { align: "right", lineHeightFactor: 0.9 });
    let running = 0;
    series.forEach((item) => {
      const value = Math.max(0, number(row[item.key]));
      if (!value) return;
      doc.setFillColor(...item.color);
      doc.setDrawColor(255, 255, 255);
      doc.setLineWidth(0.25);
      doc.rect(plotX + (running / maxValue) * plotWidth, centerY - 4.5, (value / maxValue) * plotWidth, 9, "FD");
      running += value;
    });
  });

  let legendY = plotTop + plotHeight + 17;
  const legendColumns = 3;
  const legendWidth = (usableWidth - 16) / legendColumns;
  series.forEach((item, index) => {
    const column = index % legendColumns;
    const row = Math.floor(index / legendColumns);
    const x = chartX + 8 + column * legendWidth;
    const yy = legendY + row * 13;
    doc.setFillColor(...item.color);
    doc.rect(x, yy, 7, 5, "F");
    doc.setFontSize(6.5);
    doc.setTextColor(65);
    doc.text(String(item.label || ""), x + 10, yy + 5, { maxWidth: legendWidth - 14 });
  });
  if (note) {
    legendY += keyHeight;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(6.5);
    doc.setTextColor(90);
    doc.text(note, chartX + 8, legendY, { maxWidth: usableWidth - 16 });
  }
  return y + frameHeight + PDF_CONTENT_GAP;
}

export default addHorizontalStackedBarChart;
